import {
  CreateCrmObjectRequestInterface,
  CreateCrmObjectResponseInterface,
  CRMActivityApiService,
  DeleteCrmObjectRequestInterface,
  GetMultiCrmObjectRequestInterface,
  GetMultiCrmObjectResponseInterface,
  ListCrmObjectsRequestInterface,
  ListCrmObjectsResponseInterface,
  ListFieldOptionsRequestInterface,
  ListFieldOptionsResponseInterface,
  ListFiltersRequestInterface,
  ListFiltersResponseInterface,
  UpdateCrmObjectRequestInterface,
  ValidateCrmObjectRequestInterface,
  ValidateCrmObjectResponseInterface,
} from '@vendasta/crm';
import { AbstractCrmObjectService } from './_abstract.service';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ActivityObjectService implements AbstractCrmObjectService {
  constructor(private readonly activityApiService: CRMActivityApiService) {}

  createCrmObject(request: CreateCrmObjectRequestInterface): Observable<CreateCrmObjectResponseInterface> {
    return this.activityApiService.createActivity(request);
  }

  deleteCrmObject(request: DeleteCrmObjectRequestInterface): Observable<HttpResponse<null>> {
    return this.activityApiService.deleteActivity(request);
  }

  getMultiObject(request: GetMultiCrmObjectRequestInterface): Observable<GetMultiCrmObjectResponseInterface> {
    return this.activityApiService.getMultiActivity(request).pipe(
      map((response) => {
        return {
          crmObjects: response.activities,
        };
      }),
    );
  }

  listFieldOptions(request: ListFieldOptionsRequestInterface): Observable<ListFieldOptionsResponseInterface> {
    return this.activityApiService.listActivityFieldOptions(request);
  }

  listObjects(request: ListCrmObjectsRequestInterface): Observable<ListCrmObjectsResponseInterface> {
    return this.activityApiService.listActivities(request).pipe(
      map((response) => {
        return {
          crmObjects: response.activities || [],
          pagingMetadata: response.pagingMetadata || {},
        } as ListCrmObjectsResponseInterface;
      }),
    );
  }

  listObjectsFilters(request: ListFiltersRequestInterface): Observable<ListFiltersResponseInterface> {
    return this.activityApiService.listActivityFilters(request);
  }

  updateCrmObject(request: UpdateCrmObjectRequestInterface): Observable<HttpResponse<null>> {
    return this.activityApiService.updateActivity({
      namespace: request.namespace,
      activity: request.crmObject,
      fieldMask: request.fieldMask,
    });
  }

  validateCrmObject(request: ValidateCrmObjectRequestInterface): Observable<ValidateCrmObjectResponseInterface> {
    return this.activityApiService.validateActivity(request);
  }
}
